<template>
  <div class="user">
    <MainNav />
    <div class="jumbotron jumbotron-fluid bg-light">
      <div class="container">
        <h1>User Guide</h1>
      </div>
    </div>
    <div class="container">
      <div class="container-fluid mb-4">
        <h3>ERCCIS Data Search</h3>
        <p></p>

        <h3 class="mt-4">Signing Up</h3>
        <p>
          If you want to request an ERCCIS Data Search report then you will need
          an account. You will need to fill in up the ‘sign up’ form at the
          bottom of the home page. The simple form captures all the relevant
          information we need to create your account. Please note that the
          information you provide here is used to customise your report, data
          search certificate and billing information. Password will need to be a
          combination of letters, numbers and characters and you will not be
          able to create an account without a strong enough password.
          <br />Once you have filled in the form and clicked the ‘sign up now’
          button at the bottom you will receive an automated email from ‘ERCCIS
          Data Search’ telling you about the next stage. If you have not
          received an email after 30 minutes, please check your junk email
          folder before contacting the ERCCIS Data Search Team
          (Datasearch@erccis.org.uk). <br />It is worth noting that ERCCIS aims
          to complete all ERCCIS Data Search account requests within 1 (one)
          working day, but it can take much longer during busy periods.
        </p>
        <p class="text-center">
          <img :src="imgSignup" alt="Sign up Up" />
        </p>

        <h3 class="mt-4">ERCCIS Data Search Account Authorisation</h3>
        <p>
          After the ERCCIS Data Search team have reviewed your account request
          they will either; grant you the relevant level of access or get in
          touch to discuss your data product requirements. Once the account is
          authorised you will receive an automated email confirming your
          successful account activation.
        </p>

        <h3 class="mt-4">Logging In</h3>
        <p>
          Once your successful account activation is confirmed you can click the
          ‘Log In’ function at the top right hand side of the home page banner.
          This activates a pop up box for you to enter your email address and
          password, followed by clicking ‘sign in’. You can also request a
          password reset if required.
        </p>
        <p class="text-center">
          <img :src="imgSignin" alt="Sign in Up" />
        </p>

        <h3 class="mt-4">Undertaking Your Search</h3>
        <p>
          Following sign in you will be taken to the interactive Data Search
          page. You can use the mapping screen to choose your desired location
          by clicking on the green pin and moving it around. Zoom level is
          controlled by +- bar or by holding down ctrl on your keyboard and
          scrolling the mouse wheel.
          <br />Once you are happy with the location request there are four
          study types that can be requested by clicking on the box. Prices
          excluding VAT are displayed and the four searches that can be
          requested are; 1 kilometer radius; 2 kilometers radius; 5 kilometers
          radius (with 2Km mapping outputs); Bat and notable birds at 5
          kilometers.
        </p>

        <p>
          Following study location and type request there are four more steps.
        </p>
        <ol>
          <li>
            Fill in your project name (please note this will appear on the
            report and certificate and billing information);
          </li>
          <li>
            Fill in your project code (please note this will appear on the
            report and billing information);
            <br />
            <span class="pl-4"
              >a. If you are using a Purchase Order (PO) this is the location to
              enter the PO.</span
            >
          </li>
          <li>
            Agree to the ERCCIS Data Search
            <a href="/terms-and-conditions">Terms and Conditions</a>
          </li>
          <li>
            Click ‘
            <i>generate your report</i>’.
          </li>
        </ol>
        <p class="text-center">
          <img :src="imgSearch" alt="Searching an area" />
        </p>

        <h3 class="mt-4">Terms and Conditions</h3>
        <p>
          Once you have clicked the accept terms and conditions and generated
          your report you are agreeing to abide by the ERCCIS Data Search Terms
          and Conditions. They can be found at:
          <a href="/terms-and-conditions"
            >https://datasearch.erccis.org.uk/terms-and-conditions</a
          >
        </p>
        <p class="text-center">
          <img :src="imgTerms" alt="Terms & Conditions Page" />
        </p>

        <h3 class="mt-4">ERCCIS Data Search Report Generation</h3>
        <p>
          Once you have clicked ‘generate your report’ it is time to get a cup
          of tea! Your report will take up to 30 minutes to be created and
          packaged. Once the information package is generated it is sent to your
          email account and stored in your search history account on ERCCIS Data
          Search for 12 months following delivery date.
          <br />If you have not received an email after 30 minutes, please check
          your junk email folder before contacting the ERCCIS Data Search Team (
          <a href="mailto:datasearch@erccis.org.uk">datasearch@erccis.org.uk</a
          >).
        </p>

        <h3 class="mt-4">ERCCIS Data Search Outputs</h3>
        <p>
          Delivery of the ERCCIS Data Search Information package is by email.
          you will receive at least four attachments to your email. These are;
        </p>
        <ol>
          <li>
            The ERCCIS Data Search report with designation and habitat data
            tables and maps, as well as summary data about SOCC species;
          </li>
          <li>The ERCCIS Data Search Certificate;</li>
          <li>
            The ERCCIS Data Search pre-filtered Excel sheet with full details of
            all notable species records hosted at ERCCIS since 1960 within your
            study requirements;
          </li>
          <li>Your Invoice or receipt, as appropriate.</li>
        </ol>
        <p class="text-center">
          <img :src="imgOutput" alt="Report Output Image" />
        </p>

        <h3 class="mt-4">Report History</h3>
        <p>
          The generated information package is stored in your search history
          account on ERCCIS Data Search for 12 months following delivery date.
          The search history can be found by clicking on the ‘Your Account’
          button in the top right hand corner. Then select the second drop down
          option ‘Report History’. Alternatively, it can be found at
          <a href="/reports/history"
            >https://datasearch.erccis.org.uk/reports/history</a
          >
          if you are signed into your account.
        </p>
        <p class="text-center">
          <img :src="imgHistory" alt="Report History Image" />
        </p>

        <h3 class="mt-4">Edit Your Details</h3>
        <p>
          You can edit your details at any time on your ERCCIS Data Search
          account. The edit account page can be found by clicking on the ‘Your
          Account’ button in the top right hand corner. Then select the third
          drop down option ‘Edit Account’. Alternatively, it can be found at
          <a href="/account/edit"
            >https://datasearch.erccis.org.uk/account/edit</a
          >
          if you are signed into your account.
        </p>
        <p class="text-center">
          <img :src="imgEdit" alt="Edit Details Image" />
        </p>

        <h3 class="mt-4">Logging out</h3>
        <p>
          Once you have finished your ERCCIS Data Search session it is a good
          idea to log out. The log out option can be found by clicking on the
          ‘Your Account’ button in the top right hand corner. Then select the
          fourth drop down option ‘Logout’.
        </p>
        <p class="text-center">
          <img :src="imgLogout" alt="Logging Out Image" />
        </p>
      </div>
      <ArrowLink
        class="my-2"
        text="Download a Copy of the User Guide"
        to="http://cornwall-wildlife-trust.azurewebsites.net/static/EDS_User_Guide_19.pdf"
        target="_blank"
        download="EDS_User_Guide_19.pdf"
      />
      <p class="text-muted">Version 1.0 - 2019</p>
    </div>
    <Footer />
  </div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";
import ArrowLink from "@/components/ArrowLink.vue";

import logout from "@/assets/img/user-guide/logout.jpg";
import edit from "@/assets/img/user-guide/edit.png";
import history from "@/assets/img/user-guide/history.png";
import output from "@/assets/img/user-guide/output.png";
import terms from "@/assets/img/user-guide/terms.png";
import search from "@/assets/img/user-guide/search.png";
import signin from "@/assets/img/user-guide/signin.png";
import signup from "@/assets/img/user-guide/signup.png";

export default {
  name: "UserGuide",
  components: {
    MainNav,
    Footer,
    ArrowLink
  },
  data() {
    return {
      imgLogout: logout,
      imgEdit: edit,
      imgHistory: history,
      imgOutput: output,
      imgTerms: terms,
      imgSearch: search,
      imgSignin: signin,
      imgSignup: signup
    };
  }
};
</script>
